import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/sv'

export default function daysjsInit (language) {
  dayjs.locale(language)
  dayjs.extend(updateLocale)
  dayjs.extend(localizedFormat)
  dayjs.updateLocale('sv', {
    weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'] // instead of lowercase default
  })
  dayjs.updateLocale('en', {
    formats: {
      L: 'DD-MM-YYYY',
    },
  })
}
